import "./header.scss";
import { Link } from "react-scroll";
import { LanguageToggleMenu } from "./shared/language-toggle";
import { MobileMenu } from "./shared/mobile-menu";
import translateSetting from "src/core/translate-setting";
import { useTranslation } from "react-i18next";
import { Link as Anchor, useLocation } from "react-router-dom";

const Header = () => {
  return (
    <header className="Header">
      <section className="logo-section">
        <img
          className="logo"
          src={require("../assets/logo/logo.png")}
          alt="Logo"
        />
      </section>
      <section className="nav-section">
        <Nav />
        <LanguageToggleMenu />
        <MobileMenu />
      </section>
    </header>
  );
};

function Nav() {
  const { t } = useTranslation();
  const navList: string[] = [
    "about",
    "video",
    "benefits",
    "features",
    "customer stories",
  ];
  let language = translateSetting.getCurrentLanguage();

  let target = window.document.querySelector("body");
  let title = window.document.querySelector("title");
  if (title) {
    title.innerText = t("page-title");
  }
  if (language !== "KOR") {
    target?.classList.add("not-kr");
  } else {
    target?.classList.remove("not-kr");
  }

  const { pathname } = useLocation();

  // Check Pathname
  let template = [];
  for (let i in navList) {
    template.push(
      <li key={i} className="nav-item">
        <Link
          activeClass="active"
          to={navList[i]}
          spy={true}
          smooth={"easeInOutQuart"}
          duration={1500}
        >
          {navList[i].toUpperCase()}
        </Link>
      </li>
    );
  }
  return <ul className="nav">{template}</ul>;
}

export default Header;
